import { Card, Select, Button } from "antd";
import { useEffect, useState } from "react";
import UsersTable from "./UsersTable";
import "./Users.css";
import { ReloadOutlined } from "@ant-design/icons";
import { getAdminUsers, restoreUser, suspendUser } from "../../services/user.service";
import { PLAN_NAME } from "../../utils";
import { Message } from "../../components/MessageProvider";

export default function UsersPage() {
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
  });

  const [filters, setFilters] = useState({})

  useEffect(() => {
    fetchUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.page, filters])

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const data = await getAdminUsers({ ...pagination, ...filters });
      setUsers(data.data);
      setPagination(prev => ({ ...prev, total: data.pagination.total, limit: data.pagination.pageSize }));
      setLoading(false);
    } catch (error) {
      console.error("Error fetching users:", error);
      setLoading(false)
    }
  }

  const handlePageChange = (page) => {
    setPagination(prev => ({ ...prev, page }));
  }

  const handleFilterChange = (value, filterKey) => {
    setFilters(prev => ({ ...prev, [filterKey]: value }));
    // implement filter logic later
  };

  const handleReset = () => {
    setFilters({});
  };

  const handleActionClick = (actionKey, record) => {
    switch (actionKey) {
      case "suspend":
        suspendUser(record._id).then(() => {
          Message.success(`User ${record.fullName} has been suspended`);
          fetchUsers();
        }).catch(error => {
          Message.error(`Failed to suspend user ${record.fullName}`);
          console.error(`Error suspending user ${record._id}:`, error);
        });
        break;
      case "restore":
        restoreUser(record._id).then(() => {
          Message.success(`User ${record.fullName} has been restored`);
          fetchUsers();
        }).catch(error => {
          Message.error(`Failed to restore user ${record.fullName}`);
          console.error(`Error restoring user ${record._id}:`, error);
        });
        break;
      case "view":
        // navigate to user details page
        break;
      default:
        break;
    }
  }

  return (
    <div className="users-page">

      {/* Title */}
      <div className="users-title">
        Total Users ({(pagination.total || 0).toString().padStart(2, "0")})
      </div>

      {/* Filters */}
      <div className="users-filters">

        <span className="filters-label">Filters</span>

        <div className="filters-container">
          <Select
            placeholder="Role"
            allowClear
            className="filter-select"
            value={filters.roleName || undefined}
            onChange={(value) => handleFilterChange(value, "roleName")}
            options={[
              { value: "admin", label: "Admin" },
              { value: "app_user", label: "User" },
            ]}
          />

          <Select
            placeholder="Tier"
            allowClear
            className="filter-select"
            value={filters.planName || undefined}
            onChange={(value) => handleFilterChange(value, "planName")}
            options={PLAN_NAME ? Object.entries(PLAN_NAME).map(([value, label]) => ({ value, label })) : []}
          />
          {/* <Select
            placeholder="Country"
            allowClear
            className="filter-select"
            onChange={(value) => handleFilterChange(value, "country")}
            options={[
              { value: "South Asia", label: "South Asia" },
              { value: "North America", label: "North America" },
              { value: "Europe", label: "Europe" },
              { value: "Oceania", label: "Oceania" },
              { value: "Africa", label: "Africa" },
            ]}
          /> */}
          <Select
            placeholder="Subscription Status"
            allowClear
            className="filter-select"
            value={filters.subscriptionStatus || undefined}
            onChange={(value) =>
              handleFilterChange(value, "subscriptionStatus")
            }
            options={[
              { value: "active", label: "Active" },
              { value: "trial", label: "Trial" },
              { value: "cancelled", label: "Cancelled" },
              { value: "expired", label: "Expired" },
            ]}
          />
          {/* <Select
            placeholder="Last Active"
            allowClear
            className="filter-select"
            onChange={(value) =>
              handleFilterChange(value, "lastActive")
            }
            options={[
              { value: "today", label: "Today" },
              { value: "7days", label: "Last 7 days" },
            ]}
          /> */}
          {/* <Select
            placeholder="High Scans"
            allowClear
            className="filter-select"
            onChange={(value) =>
              handleFilterChange(value, "highScans")
            }
            options={[
              { value: "10+", label: "10+" },
              { value: "50+", label: "50+" },
              { value: "100+", label: "100+" },
            ]}
          />
          <Select
            placeholder="New Users"
            allowClear
            className="filter-select"
            onChange={(value) =>
              handleFilterChange(value, "newUsers")
            }
            options={[
              { value: "today", label: "Today" },
              { value: "7days", label: "Last 7 days" },
              { value: "30days", label: "Last 30 days" },
            ]}
          /> */}
          <Button type="link" className="reset-btn" onClick={handleReset}>
            <ReloadOutlined />
            Reset
          </Button>
        </div>

      </div>

      {/* Table */}
      <Card className="users-card" bordered={false}>
        <UsersTable users={users} loading={loading} pagination={pagination} onPageChange={handlePageChange} handleActionClick={handleActionClick} />
      </Card>

    </div>
  );
}
